import type { BinaryAttachment, JsonValue, RunId, WorkflowId } from "./workflowTypes";
import type { NodeId } from "./baseTypes";

export type WorkspaceId = string;

export type DispatchBinaryRef = BinaryAttachment;

export interface DispatchItemMeta {
  readonly id: string;
  readonly json?: JsonValue;
  readonly binary?: Readonly<Record<string, DispatchBinaryRef>>;
}

export interface WorkflowDispatch {
  readonly runId: RunId;
  readonly workspaceId: WorkspaceId;
  readonly workflowId: WorkflowId;
  readonly triggerNodeId: NodeId;
  readonly items: ReadonlyArray<DispatchItemMeta>;
  readonly triggerContext: JsonValue;
}

export function serializeDispatch(dispatch: WorkflowDispatch): string {
  return JSON.stringify(dispatch);
}

export function deserializeDispatch(raw: string): WorkflowDispatch {
  return JSON.parse(raw) as WorkflowDispatch;
}
